import { type PropsWithChildren, useEffect, useRef } from 'react';
import { useLayoutEffect } from './use-isomorphic-layout-effect';

export type UnmountCleanupProps = PropsWithChildren<{
	/**
	 * Runs when this wrapper unmounts. The latest function is used (ref synced each commit).
	 * Prefer idempotent work (e.g. resetting a product trigger).
	 */
	onCleanup?: () => void;
}>;

/**
 * Runs `onCleanup` when the wrapper unmounts. Wrap arbitrary UI without a custom component + effect.
 */
export const UnmountCleanup = ({ onCleanup, children }: UnmountCleanupProps): JSX.Element => {
	const onCleanupRef = useRef(onCleanup);
	useLayoutEffect(() => {
		onCleanupRef.current = onCleanup;
	});
	useEffect(() => {
		return () => {
			onCleanupRef.current?.();
		};
	}, []);
	return <>{children}</>;
};
